// src/components/goal-dashboard/GoalSelectionBar.tsx
import {
  Autocomplete,
  TextField,
  Box,
  Typography,
  Button,
  Checkbox,
} from "@mui/material";
import { useGoalDashboardContext } from "../../../contexts/GoalSettingDashboardContext";
import { useTranslation } from "react-i18next";
import { common, input } from "../../../i18n";
import alertService from "../../../components/alert/alertService";
import { useNavigate } from "react-router-dom";
import { GoalSettingContext } from "../../../contexts/GoalSettingContext";
import { useEffect } from "react";

export const GoalSelectionBar = () => {
    const {t} = useTranslation([common, input], {nsMode: "fallback"})
    const navigate = useNavigate()
  const { allGoals, selectedGoalIds, setSelectedGoalIds } =
    useGoalDashboardContext();

    const handleChange = (_: any, values: any[]) => {
        if (values.length > 5) {
          alertService.warning(
            t("Display-a-maximum-of-5-goals")
          );
          return; // ❌ ไม่อัปเดตค่า
        }
        setSelectedGoalIds(values.map((v) => v.goalRefId));
      };
    
      const options = allGoals;
      const selectedGoals = allGoals.filter((g) =>
        selectedGoalIds.includes(g.goalRefId)
      );

  return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        gap={2}
        flexWrap="wrap" // ✅ ให้ responsive ดีบนจอเล็ก
      >
        <Box flex={0.5}>
        <Autocomplete
          size="small"
          multiple
          limitTags={3}
          disableCloseOnSelect
          options={options}
          value={selectedGoals}
          getOptionLabel={(option) => option.name}
          onChange={handleChange}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                checked={selected}
                style={{ marginRight: 8 }}
                size="small"
              />
              {option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("Goal")}
              sx={{ zIndex: 0 }}
            />
          )}
          sx={{
            width: "100%",
            backgroundColor: "var(--white)",
            "& .MuiAutocomplete-tag": {
              maxWidth: "40%",
            },
            ".MuiAutocomplete-inputRoot": {
              minHeight: "40px",
              flexWrap: "nowrap !important",
            },
          }}
        />

        </Box>


        {/* ปุ่ม Add Goal */}
        <Button
          variant="contained"
          color="secondary"
          startIcon={<img src="/img/add-circle.svg" alt="" />}
          sx={{
            whiteSpace: "nowrap",
            alignSelf: "center",
            maxHeight: 40,
          }}
          onClick={() => {
            navigate("/goal-setting/add-goal?open=true");
          }}
        >
          {t("Add-Goal")}
        </Button>
      </Box>
  );
};
